import { render } from "./SystemTabFuso.vue?vue&type=template&id=05af72b2&scoped=true&ts=true"
import script from "./SystemTabFuso.vue?vue&type=script&lang=ts"
export * from "./SystemTabFuso.vue?vue&type=script&lang=ts"

import "./SystemTabFuso.vue?vue&type=style&index=0&id=05af72b2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05af72b2"]])

export default __exports__